module.exports = __webpack_public_path__ + "media/components/partials/LandingComponents/General/Header/img/logo-ee4918136d2b889a85ce0cd97ee080ac.svg";